import { render, staticRenderFns } from "./EmailPreviewDialog.vue?vue&type=template&id=0cc87438&"
import script from "./EmailPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./EmailPreviewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports